import { fetchFromOldApi } from '~/services/Http';

import { Employees } from '../employees/types';
export * from './useGetManagerEmployeeRelationshipType';

export enum RelationshipType {
  Direct = 'DIRECT',
  Indirect = 'INDIRECT',
  All = 'ALL',
  None = 'NONE',
}

export const getTeamEmployeeList = (
  treeId: number,
  employeeId: number,
): Promise<Employees[]> =>
  fetchFromOldApi(`/json/org/tree/${treeId}/manager/${employeeId}/empsub`).then(
    (r) => r.json(),
  );

export const getMyDeputyDirUnits = (employeeId: number): Promise<number[]> =>
  fetchFromOldApi(`/json/auth/role/DEPUTY_MANAGER/${employeeId}/unit`).then(
    (r) => r.json(),
  );

export const getMyAltDirUnits = (employeeId: number): Promise<number[]> =>
  fetchFromOldApi(`/json/auth/role/ALT_MANAGER/${employeeId}/unit`).then((r) =>
    r.json(),
  );

export const getMgrEmpRelationship = async (
  employeeId: number,
  targetId: number,
): Promise<RelationshipType> =>
  await fetchFromOldApi(
    `/json/org/tree/1/manager/${employeeId}/emp/${targetId}`,
  ).then((r) => r.json());

export const sortSearchItems = (employees: Employees[]): Employees[] =>
  [...employees].sort((item1, item2) =>
    (item1.fEmpLastName + ', ' + item1.fEmpFirstName).toLowerCase() >
    (item2.fEmpLastName + ', ' + item2.fEmpFirstName).toLowerCase()
      ? 1
      : -1,
  );
